/** @jsx h */
import { h } from 'preact'

const Link = ({ href, className, children }) => {
  return (
    <a
      href={href}
      className={`rcc-block rcc-uppercase rcc-underline rcc-tracking-widest rcc-text-xs rcc-text-center ${className}`}
    >
      {children}
    </a>
  )
}

export default Link
